<template>
  <v-container fluid class="mt-16">
    <div class="noimprimir">
      <v-text-field
        prepend-inner-icon="mdi-magnify"
        dense
        autofocus
        @input="buscarClienteMostrador()"
        v-model="search"
        label="Búsqueda..."
        single-line
        solo
        autocomplete="new"
        clearable
      ></v-text-field>
      <v-data-table
        hide-default-footer
        :headers="headers"
        :items="remitentesParaAbonoList"
        item-key="ID"
      >
        <template #item.actions="{ item }">
          <v-btn
            v-if="item.Deuda > 0"
            @click="
              idClienteAdeudo = item.ID;
              nombreClienteAbonador = item.NOMBRE_COMPLETO;
              telefonoClienteAbonador = item.TELEFONO;
              mostrarModalAbonoMultiple = true;
            "
            color="green"
            class="mr-2"
            text
            rounded
            dark
          >
            Abonar
            <v-icon small class="mr-2">
              mdi-cash-multiple
            </v-icon>
          </v-btn>
        </template>
        <template #item.deudaTotal="{ item }">
          <span style="font-weight:bold;"> {{ formateaMoneda(item.Deuda) }} </span>
        </template>
      </v-data-table>
      <v-overlay :value="loaderModalClientes">
        <v-progress-circular indeterminate size="100"></v-progress-circular>
      </v-overlay>
    </div>
    <div class="imprimir">
      <TicketDeCompra />
    </div>
    <AbonoMultiples
      :nombreDeCliente="nombreClienteAbonador"
      :telefonoDeCliente="telefonoClienteAbonador"
      @actualizarAbonosMultiples="actualizaAbonosMultiplesX"
      v-if="mostrarModalAbonoMultiple"
      @cerrar-modal-abono-multiple="mostrarModalAbonoMultiple = false"
      :show="mostrarModalAbonoMultiple"
      :idClientePasado="idClienteAdeudo"
    />
    <v-snackbar
      v-model="snackbarExito"
      timeout="2000"
      rounded="pill"
      centered
      elevation="8"
      color="blue darken-1"
      ><span style="font-size:20px;">
        Abono realizado con éxito <v-icon medium> mdi-check-circle </v-icon>
      </span></v-snackbar
    >
  </v-container>
</template>
<script>
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
import TicketDeCompra from "@/components/TicketDeCompra.vue";
import _ from "lodash";
import AbonoMultiples from "@/components/modales/ModalAbonoMultiple.vue";
import { mapState, mapActions } from "vuex";
export default {
  data: () => ({
    nombreClienteAbonador: "",
    telefonoClienteAbonador:"",
    snackbarExito: false,
    idClienteAdeudo: 0,
    mostrarModalAbonoMultiple: false,
    search: "",
    loaderModalClientes: false,
    headers: [
      {
        text: "Alias",
        align: "center",
        sortable: false,
        value: "ALIAS"
      },
      {
        text: "Nombre",
        align: "center",
        sortable: false,
        value: "NOMBRE_COMPLETO"
      },
      {
        text: "Teléfono",
        align: "center",
        sortable: false,
        value: "TELEFONO"
      },
      {
        text: "Sucursal",
        align: "center",
        sortable: false,
        value: "SUCURSAL"
      },
      {
        text: "Deuda total",
        align: "center",
        sortable: false,
        value: "deudaTotal"
      },
      {
        text: "",
        align: "center",
        sortable: false,
        value: "actions"
      }
    ]
  }),
  components: {
    AbonoMultiples,
    TicketDeCompra
  },
  computed: {
    ...mapState("abonosEnvios", {
      remitentesParaAbonoList: state => state.remitentesParaAbonos
    }),
    cadenaBusqueda() {
      return this.search == null ? "" : this.search;
    }
  },
  async mounted() {
    await this.buscarClienteMostrador();
  },
  methods: {
    ...mapActions("abonosEnvios", ["getRemitentesParaAbonos"]),
    async actualizaAbonosMultiplesX() {
      await this.buscarClienteMostrador();
      this.snackbarExito = true;
      await this.imprimirTicket();
    },
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    },
    async imprimirTicket() {
      window.print();
      window.print();
    },
    buscarClienteMostrador: _.debounce(async function() {
      this.loaderModalClientes = true;
      const resR = await this.getRemitentesParaAbonos(this.cadenaBusqueda);
      if (resR[0]) {
        this.loaderModalClientes = false;
      }
    }, 400)
  }
};
</script>
<style lang="css">
tr.v-data-table__selected {
  background: #7d92f5 !important;
  color: white !important;
  font-weight: bold !important;
}
.v-data-table .v-data-table__mobile-table-row {
  display: block !important;
}
</style>

<style lang="css" scoped>
.imprimir {
  display: none;
}
@media print {
  .noimprimir {
    display: none;
  }
  .imprimir {
    display: block;
  }
}
</style>
